import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScdPickerComponent } from './scd-picker.component';
import { ScdPickerOptionComponent } from './scd-picker-option/scd-picker-option.component';
import { InputModule } from '../input/input.module';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { TooltipModule } from '../tooltip/tooltip.module';

@NgModule({
    declarations: [ScdPickerComponent, ScdPickerOptionComponent],
    imports: [CommonModule, InputModule, CheckboxModule, TooltipModule],
    exports: [ScdPickerComponent, ScdPickerOptionComponent]
})
export class ScdPickerModule {}
